// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const LoginLink: MarkdocTagRegistration = {
  tag: 'login-link',
  component: 'LoginLink',
  description:
    'Render a link to the login page with redirect url set to current location',
  children: ['strong', 'em', 'code', 'text', 'tag'],
  attributes: {
    title: {
      type: String,
      description: 'The value for the html title attribute',
      localizable: true,
    },
    id: {
      type: String,
      description: 'The value for the html id attribute',
      localizable: false,
    },
  },
};
